<!--价格管理 销售报价分组 匹配客户-->
<template>
  <div>
    <el-row>
      <el-col>
        <el-button size="medium" @click="matchProduct" style="margin-top:20px">匹配客户</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table stripe border :data="tableData" style="margin-top:20px">
          <el-table-column label="序号" type="index" width="50px"></el-table-column>
          <el-table-column label="客户名称" prop="NAME"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="deleteProduct(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!-- 新增匹配 -->
    <el-dialog title="新增匹配" center :visible.sync="addFormVisible" width="400px">
      <el-form size="small" :model="addForm" ref="addForm">
        <el-form-item label="分组名称：" :label-width="formLabelWidth">
          <el-select filterable v-model="addForm.CUSTOMER">
            <el-option v-for="item in customerList" :key="item.ID" :value="item.ID" :label="item.NAME"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close">取 消</el-button>
        <el-button size="small" @click="submitAdd">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getPriceGroupCusFun, deleteMatchCusFun, getNotMatchCusFun, matchCusFun,
} from 'api/systemSetting';

export default {
  data() {
    return {
      tableData: [],
      kindsId: sessionStorage.getItem('areaId'),
      customerList: [],
      addFormVisible: false,
      addForm: {},
      formLabelWidth: '100px',
    };
  },
  methods: {
    addProduct() {
      this.$router.push({ name: 'addNewProduct' });
      sessionStorage.setItem('kindId', this.kindsId);
    },
    matchProduct() {
      this.addFormVisible = true;
      this.queryNotMatch();
    },
    // ---------------------------进入页面拉取数据
    queryTable() {
      const params = {
        AREA_ID: Number(this.kindsId),
      };
      getPriceGroupCusFun(params)
        .then((result) => {
          if (result[0]) {
            this.tableData = result;
          } else {
            this.tableData = [];
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // ------------------------------删除数据
    deleteProduct(row) {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            TC_ID: row.TC_ID,
            AREA_ID: Number(this.kindsId),
          };
          deleteMatchCusFun(params)
            .then((result) => {
              this.$message.show({ text: '删除成功', type: 'success' });
              this.queryTable();
              document.body.style.cursor = 'default';
            }).catch((error) => {
              this.$message.show({ text: error, type: 'error' });
              document.body.style.cursor = 'default';
            });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
    queryNotMatch() {
      const params = {};
      getNotMatchCusFun(params)
        .then((result) => {
          this.customerList = result;
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    submitAdd() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            TC_ID: this.addForm.CUSTOMER,
            AREA_ID: Number(this.kindsId),
          };
          if (!this.addForm.CUSTOMER) {
            this.$message.show({ text: '请选择分组名称', type: 'warning' });
            return false;
          }
          matchCusFun(params)
            .then((result) => {
              this.$message.show({ text: '新增成功', type: 'success' });
              this.addFormVisible = false;
              this.queryTable();
              document.body.style.cursor = 'default';
            }).catch((error) => {
              this.$message.show({ text: error, type: 'error' });
              document.body.style.cursor = 'default';
            });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
    handleCurrentChange() {
      this.queryTable();
    },
    close() {
      this.addFormVisible = false;
    },
  },
  created() {
    this.queryTable();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/priceManagement/matchPriceGroup.vue